/**
 * Title Case PT-BR — capitaliza cada palavra, exceto preposições/artigos
 * curtos no meio do nome. Padrão usado em documentos brasileiros.
 *
 * Ex: "maria da silva" → "Maria da Silva"
 *     "josé dos santos" → "José dos Santos"
 *     "da vinci pereira" → "Da Vinci Pereira" (primeira sempre capitaliza)
 *
 * Preserva espaços exatos do input (não colapsa) pra não quebrar cursor
 * durante digitação.
 */
const LOWERCASE_WORDS = new Set([
  "da",
  "de",
  "di",
  "do",
  "du",
  "das",
  "des",
  "dos",
  "e",
  "a",
  "o",
  "el",
]);

export function titleCasePtBR(s: string): string {
  if (!s) return s;
  // Mantém os espaços originais exatamente como digitados:
  // separa por "palavra" vs "espaço em branco" mas preserva tamanhos.
  let wordIndex = 0;
  return s.replace(/(\S+)/g, (match) => {
    const lower = match.toLowerCase();
    const isFirst = wordIndex === 0;
    wordIndex++;
    if (!isFirst && LOWERCASE_WORDS.has(lower)) return lower;
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  });
}
